module.exports = __webpack_public_path__ + "scripts/media/logo.08270b97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 7037
// module chunks = 0